import React from "react";

type ProjectInfoProps = {
  img: string;
  href: string;
  type: string;
};

const ProjectInfo: React.FC<ProjectInfoProps> = ({ img, href, type }) => {
  return (
    <div className={"project-info"}>
      <img className={"project-info__img"} src={img} alt={"Project logo"} />
      <div className={"project-info__type"}>{type}</div>
    </div>
  );
};

export default ProjectInfo;
